module.exports = __webpack_public_path__ + "../resources/images/emptyDeletedItemsFolder-ad4349d7bee61d74b196641688d4920d.svg";